export const LeadStageStatus = {
  newLead: 'New Inquiry',
};
